<template>
    <div class="content">
        <div class="top-bar">
            <a class="icon icon-return" href="javascript: history.go(-1)"></a>
            <router-link tag="a" to="/member/index" class="icon icon-home" href="javascript: void(0)"></router-link>
        </div>
        <div class="commodity-detail">
            <div class="detail-hd">
                <div id="picBanner" class="pic-box swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in product.Pictures" :key="index">
                            <img :src="item" :alt="product.Name">
                        </div>
                    </div>
                    <div class="pagination" v-if="picsLength > 1"></div>
                </div>
                <div class="text-box wrap">
                    <h3>{{product.Name}}</h3>
                    <div class="price-wrap">
                        <div class="price-item price-new"><i class="cur">{{product.Price}}</i>积分</div>
                        <div class="price-item price-old" v-if="product.OldPrice">{{product.OldPrice}}积分</div>
                        <div class="recommend-tips" v-if="bntText==='积分不足'">
                            <router-link to="/recommend/courtesy">赚更多积分</router-link>
                        </div>
                    </div>
                    <div v-if="product.IsPurchaseLimit" class="purchaseLimitCount">限购数量：{{product.PurchaseLimitCount}}</div>
                </div>
            </div>
            <div class="detail-bd wrap">
                <div class="detail-text">
                    <div class="detail-text">
                        <p class="item-title" style="display: flex; display: -webkit-flex; align-items: center; -webkit-align-items: center; height: 40px; padding-bottom: 15px; font-size: 16px;"><span>商品详情</span></p>
                        <p class="show-item" v-html="product.FullDescription"></p>
                    </div>
                    <br>
                    <div class="detail-text">
                        <p class="item-title" style="display: flex; display: -webkit-flex; align-items: center; -webkit-align-items: center; height: 40px; padding-bottom: 15px; font-size: 16px;"><span>兑换说明</span></p>
                        <p class="show-item" v-html="product.ExchangeExplain"></p>
                    </div>
                    <!--<p class="item-title" style="display: flex; display: -webkit-flex; align-items: center; -webkit-align-items: center; height: 40px; padding-bottom: 15px; font-size: 16px;">
                        商品详情
                    </p>
                    <p style="padding-left: 7px; color: #747d80; line-height: 18px; word-break: break-all; word-wrap: break-word;">
                        这是一个测试商品，没有商品详情，只有这一段文字。
                    </p>
                    <p style="padding-left: 7px; color: #747d80; line-height: 18px; word-break: break-all; word-wrap: break-word;">
                        测试商品，兑换需要20001积分，积分满足可进行兑换，快
                    </p>
                    <p class="item-title" style="display: flex; display: -webkit-flex; align-items: center; -webkit-align-items: center; height: 60px; padding-bottom: 15px; padding-top: 20px; font-size:16px;">
                        兑换说明
                    </p>
                    <p style="padding-left: 7px; color: #747d80; line-height: 18px; word-break: break-all; word-wrap: break-word;">
                        这是一个测试商品，没有商品详情，只有这一段文字。
                    </p>
                    <p style="padding-left: 7px; color: rgb(116, 125, 128); line-height: 18px; word-break: break-all; overflow-wrap: break-word;">
                        测试商品，兑换需要20001积分，积分满足可进行兑换，快
                    </p>-->
                </div>
            </div>
            <div class="bot-btn hvc">
                <a :class="`btn-item btn-exchange ${isDisabled} hvc`" @click="goNext" href="javascript: void(0)">{{bntText}}</a>
            </div>
        </div>
        <div class="message-layer" v-if="msgShow">
            <div class="message-content">
                <div class="msg-text">
                    <h3>{{msgTitle}}</h3>
                    <div class="msg-tip hvc" v-html="msgTip"></div>
                </div>
                <div class="msg-icon hc">
                    <i class="icon icon-error" v-if="msgType === 'error'"></i>
                    <i class="icon icon-success" v-if="msgType === 'success'"></i>
                    <i class="icon icon-checking" v-if="msgType === 'checking'"></i>
                </div>
                <div class="bottom-btn" v-if="msgType === 'error'">
                    <a class="btn-item btn-close hvc" href="javascript: void(0)" @click="closeMsg">关闭</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import 'swiper/dist/css/swiper.css'
    import Swiper from 'swiper'
    import {delayDev} from "../../../libs/tools";
    export default {
        name: 'commodityDetail',
        data: () => {
            return {
                picSwiper: null,
                product: {},
                picsLength: 0,
                userPoint: 0,
                bntText: '立即兑换',
                isDisabled: '',
                isLoop: false,
                msgShow: false,
                msgType: '', // success-成功  checking-待审核  error-出错了
                msgTitle: '',
                msgTip: ''
            }
        },
        mounted () {
            this.getDetailById(this.$route.query.Id)
                .then(res => {
                    // 判断库存
                    if (res.StockQuantity === 0) {
                        this.isDisabled = 'disabled'
                        this.msgShow = true
                        this.msgType = 'error'
                        this.msgTitle = '系统提示'
                        this.msgTip = '抱歉，库存不足！'
                    }

                    this.product = res
                    this.picsLength = res.Pictures.length
                    this.isLoop = this.picsLength > 1

                    // 加载pro-banner
                    delayDev(300, () => {
                        this.picSwiper = new Swiper('#picBanner', {
                            loop: this.isLoop,
                            slidesPerView: 'auto',
                            pagination: {
                                el: '.pagination',
                                type: 'bullets',
                                bulletElement: 'span'
                            },
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: false
                            }
                        })
                    })
                    if(res.IsPurchaseLimit && res.AvailableExchangeQuantity===0){
                      this.isDisabled = 'disabled'
                    }
                    // 加载积分
                    return this.getUserPoint()
                })
                .then(res => {
                    this.userPoint = res.userPoint

                    if (this.userPoint < this.product.Price) {
                        this.bntText = '积分不足'
                        this.isDisabled = 'disabled'
                    }
                })
        },
        methods: {
            closeMsg () {
                this.msgShow = false
            },
            goNext () {
                try {
                    window.gio('track', 'RedeemGift', {'GiftID': this.product.Id});
                } catch (e) {
                    //console.log(e);
                }

                if (this.product.GiftType === 10) {
                    this.$router.push(`/commodity/account?Id=${this.product.Id}&VirtualProductType=${this.product.VirtualProductType}`)
                } else if (this.product.GiftType === 20) {
                    this.$router.push(`/commodity/receiving?Id=${this.product.Id}&VirtualProductType=${this.product.VirtualProductType}`)
                } else if (this.product.GiftType === 30) {
                    this.$router.push(`/commodity/coupon?Id=${this.product.Id}&VirtualProductType=${this.product.VirtualProductType}`)
                }
            },
            getUserPoint () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserPoint',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getDetailById (Id) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMProduct/GetDetailById',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            Id,
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .top-bar{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99;
        width: 100%;
        height: 0;
        .icon{
            position: absolute;
            top: 0.20rem;
            width: 0.60rem;
            height: 0.60rem;
            &.icon-return{
                left: 0.18rem;
                background: url("../../../assets/images/return_circle.png") no-repeat;
                background-size: 100% 100%;
            }
            &.icon-home{
                right: 0.18rem;
                background: url("../../../assets/images/home_circle.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .commodity-detail{
        background-color: #f5f6f8;
        .detail-hd{
            margin-bottom: 0.20rem;
            background-color: #fff;
            .pic-box{
                height: 4.80rem;
                .swiper-slide{
                    display: flex;
                    display: -webkit-flex;
                    align-items: center;
                    -webkit-align-items: center;
                    height: 4.80rem;
                    overflow: hidden;
                    img{
                        width: 100%;
                    }
                }
                .pagination{
                    position: absolute;
                    left: 0;
                    bottom: 0.20rem;
                    z-index: 9;
                    width: 100%;
                    height: 0.20rem;
                    text-align: center;
                    .swiper-pagination-bullet{
                        width: 0.12rem;
                        height: 0.12rem;
                        background: #b2babe;
                    }
                    .swiper-pagination-bullet-active{
                        background: #fbc500;
                    }
                }
            }
            .text-box{
                padding-top: 0.24rem;
                padding-bottom: 0.20rem;
                h3{
                    font-size: 0.30rem;
                    line-height: 1;
                }
                .price-wrap{
                    display: flex;
                    display: -webkit-flex;
                    height: 0.40rem;
                    margin-top: 0.30rem;
                    .price-old{
                        padding-top: 0.16rem;
                        color: #747d80;
                        line-height: 1;
                        text-decoration: line-through;
                    }
                    .price-new{
                        margin-right: 0.20rem;
                        color: #ffa70d;
                        line-height: 1;
                        .cur{
                            font-size: 0.46rem;
                            font-weight: bold;
                        }
                    }
                    .recommend-tips { 
                        position: relative;
                        top: 4px;
                        margin-left: 10px;
                        color: #4a90e2;
                    }
                }
              .purchaseLimitCount{
                color: #747d80;
                margin-top: 8px;
              }
            }
        }
        .detail-bd{
            padding-top: 0.40rem;
            padding-bottom: 1.45rem;
            background-color: #fff;
            /*.item-wrap{
                margin-bottom: 0.40rem;
                .item-title{
                    height: 0.80rem;
                    padding-bottom: 0.34rem;
                    font-size: 0.30rem;
                    .icon-line{
                        width: 0.04rem;
                        height: 0.30rem;
                        margin-right: 0.10rem;
                        background-color: #fbc500;
                        border-radius: 0.02rem;
                    }
                }
                .item-detail{
                    padding-left: 0.14rem;
                    color: #747d80;
                    line-height: 0.32rem;
                    word-break: break-all;
                    word-wrap: break-word;
                }
            }*/
        }
        .bot-btn{
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1.25rem;
            border-top: #d4dbde solid 0.02rem;
            background-color: #fff;
            .btn-exchange{
                display: flex;
                display: -webkit-flex;
                width: 6.92rem;
                height: 0.95rem;
                border-radius: 0.07rem;
                background-color: #fbc500;
                font-size: 0.30rem;
                &.disabled{
                    background-color: #eaeaeb;
                    color: #747d80;
                    pointer-events: none;
                }
            }
        }
    }
</style>
